import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";

import Body from "../theme/Body";

import Compensation from "./Compensation";
import NewCompensationButton from "./NewCompensationButton";

const CompensationList = ({
  compensations,
  eventId,
  future,
  refreshList,
}: {
  future: boolean;
  compensations: Compensation[];
  eventId: string;
  refreshList: () => void;
}) => {
  return (
    <>
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }}
        justifyContent="space-between"
        marginBottom="1em"
      >
        <Typography
          component="h2"
          sx={{ marginY: { xs: "1em", sm: 0 } }}
          variant="h2"
        >
          Aanvragen
        </Typography>
        <NewCompensationButton
          eventId={eventId}
          future={future}
          refreshList={refreshList}
        />
      </Stack>
      {compensations.length === 0 ? (
        <Body>
          Er zijn geen openstaande aanvragen. Kom later terug als je de
          reiskosten van een demonstrant wil betalen.
        </Body>
      ) : (
        compensations.map((compensation) => (
          <Compensation
            compensation={compensation}
            key={compensation.id}
            refreshList={refreshList}
          />
        ))
      )}
    </>
  );
};

export default CompensationList;
